import { HTTP } from "../../../../services/api-service.js";
import commonObj from "../../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "Warehouse";

const locationStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    getAllLocation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", state.q)
          .then(response => {
            // 过滤掉删除的记录
            response.data.Data.Data = response.data.Data.Data.filter(
              item => !item.RecDel
            );
            response.data.Data.Total = response.data.Data.Data.length;
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveLocation({ commit }, param) {
      const DBmodel = {
        Location: "",
        LocationDescription: "",
        EnglishAddress1: "",
        EnglishAddress2: "",
        EnglishAddress3: "",
        EnglishAddress4: "",
        PhoneNumber: "",
        FaxNumber: "",
        ContactPerson: "",
        ChiAddress1: "",
        ChiAddress2: "",
        ChiAddress3: "",
        ChiAddress4: "",
        Country: "",
        District: "",
        Area: "",
        LocationType: "",
        DateClosed: "",
        DateOpen: ""
      };
      // 处理每个模型项，确保所有字段存在且 null/undefined 被替换为空字符串
      const processedModelList = param.locationModel.map(model => {
        // 解析 JSON 字符串为对象
        let itemData =
          typeof model.item1 === "string"
            ? JSON.parse(model.item1)
            : model.item1;

        // 合并默认模型和实际数据
        let mergedData = Object.assign({}, DBmodel, itemData);

        // 遍历所有字段，将 null 或 undefined 替换为空字符串
        Object.keys(mergedData).forEach(key => {
          if (mergedData[key] === null || mergedData[key] === undefined) {
            mergedData[key] = "";
          }
        });
        return {
          item1: JSON.stringify(mergedData),
          item2: model.item2
        };
      });
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName,
            modelList: processedModelList,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default locationStore;
